import styled from "styled-components";

export const ProgramSectionListStyled = styled.div`
  overflow-x: hidden;
`;

export const ProgramFreeSelectionItemStyled = styled.div``;
